import React from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  FormGroup,
  Label,
  Input
} from "reactstrap";
import { Mantenimiento, LoadingStates } from "../horariosClubesComponentTypes";

interface Props {
  isOpen: boolean;
  toggle: () => void;
  mantenimientos: Mantenimiento[];
  mantenimientosSeleccionados: string[];
  onMantenimientoChange: (mantenimientoIds: string[]) => void;
  onGuardar: () => void;
  loadingStates: LoadingStates;
  isAnyOperationInProgress: () => boolean;
  onSeleccionarTodosMantenimientos: () => void;
}

const ModalEditarMantenimientos: React.FC<Props> = ({
  isOpen,
  toggle,
  mantenimientos,
  mantenimientosSeleccionados,
  onMantenimientoChange,
  onGuardar,
  loadingStates,
  isAnyOperationInProgress,
  onSeleccionarTodosMantenimientos
}) => {
  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>Editar Mantenimientos</ModalHeader>
      <ModalBody>
        <div className="d-flex justify-content-between align-items-center mb-2">
          <Label>Selección de mantenimientos</Label>
          <Button
            color="danger"
            size="sm"
            onClick={onSeleccionarTodosMantenimientos}
          >
            Seleccionar Todos
          </Button>
        </div>
        <div
          style={{
            maxHeight: "400px",
            overflowY: "auto",
            border: "1px solid #dee2e6",
            padding: "10px",
            borderRadius: "4px"
          }}
        >
          {mantenimientos.map((mant: any) => (
            <FormGroup check key={mant.id} className="mb-1">
              <Label check>
                <Input
                  type="checkbox"
                  style={{
                    accentColor: "#dc3545"
                  }}
                  checked={mantenimientosSeleccionados.includes(
                    mant.id.toString()
                  )}
                  onChange={e => {
                    if (e.target.checked) {
                      onMantenimientoChange([
                        ...mantenimientosSeleccionados,
                        mant.id.toString()
                      ]);
                    } else {
                      onMantenimientoChange(
                        mantenimientosSeleccionados.filter(
                          id => id !== mant.id.toString()
                        )
                      );
                    }
                  }}
                />
                <small>
                  {mant.id} - {mant.nombre}
                </small>
              </Label>
            </FormGroup>
          ))}
        </div>
        <small className="text-muted mt-2 d-block">
          {mantenimientosSeleccionados.length} seleccionados
        </small>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={toggle}>
          Cancelar
        </Button>
        <Button
          color="danger"
          onClick={onGuardar}
          disabled={isAnyOperationInProgress()}
        >
          {loadingStates.updating ? (
            <>Actualizando...</>
          ) : (
            "Guardar Mantenimientos"
          )}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default ModalEditarMantenimientos;
